import { Routes } from '@angular/router';
import { EventsUpcomingComponent } from '../events/upcoming/feature/upcoming.component';
import { ShowComponent } from '../events/show/feature/show.component';
import { EventBookingComponent } from '../events/book/feature/book.component';
import { AuthGuard } from '../data-services/guards/auth.guard';

export const eventsRoutes: Routes = [
    {
        path: 'events',
        component: EventsUpcomingComponent
    },
    {
        path: 'events/:id',
        component: ShowComponent
    },
    {
        path: 'events/:id/book',
        canActivate: [AuthGuard],
        data: {
            sidebar: false
        },
        component: EventBookingComponent
    }
]
